import Main from "layouts/Main";
import React, { FC } from "react";
import { useParams } from "react-router-dom";
import OrderAgent from "components/OrderAgent";

const OrderAgentByIdPage: FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Main namePage="จัดการคำสั่งซื้อ">
      <div className="layout-content">
        <OrderAgent id={id ?? ""} />
      </div>
    </Main>
  );
};

export default OrderAgentByIdPage